import { Component, inject } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { GenesisUnitOfWork } from 'app/core/core.module';
import { DeliveryOption } from 'app/core/model/delivery-option';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-confirmation-payment-method-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Delivery Option</h2>
        </div>
        <div class="flex-fill d-flex flex-column">
            <div class="card">
                <div class="card-body">
                    <dx-form *ngIf="deliveryOption" [formData]="deliveryOption" validationGroup="deliveryOptionValidationGroup">
                        <dxi-item itemType="group">
                            <dxi-item dataField="name" [isRequired]="true"></dxi-item>
                            <dxi-item dataField="description"></dxi-item>
                            <dxi-item dataField="requiresFreight" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="dealerOption" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="dealerConfirmationMessage" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
                            <dxi-item dataField="dealerAcknowledgementMessage" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
                            <dxi-item dataField="acknowledgementRequired" editorType="dxCheckBox"></dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-danger" (click)="save()">Save</button>
            <button class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    standalone: false,
})
export class DeliveryOptionDialogComponent {
    appInfo = inject(AppInformationService);
    uow = inject(GenesisUnitOfWork);

    result = new Subject<{ success: boolean }>();
    deliveryOption: DeliveryOption;
    displayOrder: number;

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.deliveryOption)
            this.deliveryOption = this.uow.deliveryOptions.createEntity({
                displayOrder: this.displayOrder,
            }) as DeliveryOption;
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('deliveryOptionValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('deliveryOptionValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
